import { motion } from "framer-motion";
import { howItWorks } from "../data";

export default function HowItWorks() {
  return (
    <section className="py-5">
      <div className="container py-5">
        <h2 className="text-center display-5 fw-bold mb-5">Как мы работаем</h2>
        <div className="row g-4">
          {howItWorks.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
              viewport={{ once: true }}
              className="col-md-6 col-lg-3"
            >
              <div className="text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4" style={{ width: '80px', height: '80px', fontSize: '2rem' }}>
                  {step.step}
                </div>
                <h3 className="h4 fw-bold mb-2">{step.title}</h3>
                <p className="text-secondary">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}